'use strict';
import React from 'react';
import classNames from 'classnames';

/**
 * TableHeader component.
 * Defines styling for a table header
 * Adding .is-ascending or .is-descending to Table-headerSort sets the styles for sort direction.
 *
 * @extends {React.Component}
 * @property {Boolean} isAscending Renders only the sort ascending icon indicating this sort order.
 * @property {Boolean} isDescending Renders only the sort descending icon indicating this sort order.
 * @property {Boolean} sorting Adds the sorting icons to the specified header element.
 */
class TableHeader extends React.Component {

  /**
   * @return {String} Sorting Table elements CSS classname.
   */
  getSortingClassName (isAscending, isDescending) {
    return classNames({
      'Table-headerSort': true,
      'is-ascending': isAscending,
      'is-descending': isDescending
    });
  }

  /**
   * @return {String} Header CSS classname.
   */
  getHeaderClassName (className) {
    return classNames({
      [`${className}`]: !!className,
      'Table-header': true
    });
  }

  /**
   * Renders the sorting icons options
   *
   * @return {JSX} JSX component markup.
   **/
  renderSorting (isAscending, isDescending) {
    return (
      <span className={this.getSortingClassName(isAscending, isDescending)}>
        <span className="Icon Table-sortIconAsc"></span>
        <span className="Icon Table-sortIconDesc"></span>
      </span>
    );
  }

  /**
   * Render the component
   *
   * @return {JSX} JSX component markup.
   **/
  render () {
    const { isAscending, isDescending, className, children, sorting } = this.props;
    return (
      <th className={this.getHeaderClassName(className)}>
        <a href="javascript:void(0);" className="Table-headerLink">
          { children }
          { sorting ? this.renderSorting(isAscending, isDescending) : null}
        </a>
      </th>
    );
  }
}

/**
 * @prop {propTypes} propTypes - required attributes for the TableHeader component
 */
TableHeader.propTypes = {
  isAscending: React.PropTypes.bool,
  isDescending: React.PropTypes.bool,
  sorting: React.PropTypes.bool
};

TableHeader.defaultProps = {
  isAscending: false,
  isDescending: false,
  sorting: false
};

export default TableHeader;



// WEBPACK FOOTER //
// ./src/components/clarity-ui/components/table/tableHeader.jsx